import { render, staticRenderFns } from "./greeting.vue?vue&type=template&id=69197bf4&scoped=true&"
import script from "./greeting.vue?vue&type=script&lang=js&"
export * from "./greeting.vue?vue&type=script&lang=js&"
import style0 from "./greeting.vue?vue&type=style&index=0&id=69197bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69197bf4",
  null
  
)

export default component.exports